import { isMobile } from '../utils/tool'
// 基准值，需与 vue.config.js 中的 remUnit 保持一致
const baseSize = 16
// 设置根字体函数，1920 为设计稿宽度，可根据实际情况调整
function setRem() {
  const scale = document.documentElement.clientWidth / (isMobile() ? 750 : 1920)
  // 限制最大最小缩放比例，避免字体过大或过小
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
setRem()
window.onresize = setRem